module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-custom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("Introdução:")]), _vm._v(" "), _c('p', [_vm._v("O “Fale com o Prefeito” buscará, por meio de uma metodologia simples, favorecer o diálogo entre o prefeito e a comunidade para ouvir suas demandas com vistas ao encaminhamento das solicitações aos Secretários responsáveis para análise e possível atendimento do pedido.")]), _vm._v(" "), _c('p', [_vm._v("Trata-se de um meio diferente e inovador de realizar o atendimento ao público. Às quartas-feiras os munícipes são convidados a comparecer no gabinete do Prefeito no 6º andar do Paço Municipal para expor suas demandas.")]), _vm._v(" "), _c('h3', [_vm._v("Como funciona:")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Foco principal:")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/agendas"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n\t\t\t\tIR PARA A LISTA DE AGENDAS\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "visible-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "to": "/agendas"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n\t\t\t\tIR PARA A LISTA DE AGENDAS\n\t\t\t")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-info-circle pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v("INSTRUÇÕES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('li', [_vm._v("Por meio de um ícone do programa no site oficial da Prefeitura Municipal de Sorocaba o interessado deve realizar um cadastro e obter uma senha no sistema "), _c('i', [_vm._v("on line")]), _vm._v(" de agendamento;")]), _vm._v(" "), _c('li', [_vm._v("O programa de agendamento também pode ser acessado por celular ("), _c('i', [_vm._v("smartphone")]), _vm._v(");")]), _vm._v(" "), _c('li', [_vm._v("Diante de seu cadastro, após estar logado, poderá escolher uma das datas e horários disponíveis;")]), _vm._v(" "), _c('li', [_vm._v("À partir de Janeiro/2019, serão disponibilizadas 06 (seis) agendas, para a terceira quarta-feira a cada 02 (dois) meses;")]), _vm._v(" "), _c('li', [_vm._v("Caso não tenha acesso a computador ou celular "), _c('i', [_vm._v("smartphone")]), _vm._v(" poderá fazer o agendamento em uma das Casas do Cidadão com auxílio de servidores;")]), _vm._v(" "), _c('li', [_vm._v("Próximo da data do atendimento será enviado um e-mail para confirmação da presença;")]), _vm._v(" "), _c('li', [_vm._v("Há possibilidade de cancelar o agendamento a qualquer momento, para isso é necessário acessar o sistema com seu "), _c('i', [_vm._v("login")]), _vm._v(" e senha;")]), _vm._v(" "), _c('li', [_vm._v("Solicitamos que chegue no dia do atendimento com ao menos 30 minutos de antecedência;")]), _vm._v(" "), _c('li', [_vm._v("No dia de seu agendamento a pessoa terá até 10 minutos para uma conversa direta com o Prefeito, em seu gabinete no 6º andar do Paço Municipal;")]), _vm._v(" "), _c('li', [_vm._v("Haverá uma equipe de assessores que dará apoio ao Sr. Prefeito no processo de atendimento;")]), _vm._v(" "), _c('li', [_vm._v("Como o objetivo é proporcionar acesso ao Prefeito a um maior número de pessoas, a solicitação de nova agenda somente poderá ocorrer após 90 (noventa) dias;")]), _vm._v(" "), _c('li', [_vm._v("Não haverá atendimento de pessoa jurídica, assim como apresentação de demanda de cunho comercial com o poder público;")]), _vm._v(" "), _c('li', [_vm._v("Excepcionalmente, em caso de impossibilidade do Prefeito atender, irá determinar que um adjunto seu faça o atendimento.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('li', [_vm._v("Identificar os problemas da cidade;")]), _vm._v(" "), _c('li', [_vm._v("Ouvir ideias e propostas dos participantes;")]), _vm._v(" "), _c('li', [_vm._v("Elaborar propostas de políticas públicas para o Município a partir das sugestões da população.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0aa867a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aa867a8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/commons/home.vue
// module id = 332
// module chunks = 1